/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clock_Times_OptionInputs */



/**
* | output |
* | --- |
* | "Clock Times Option" |
*
* @param {Clock_Times_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clock_times_option = /** @type {((inputs?: Clock_Times_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clock_Times_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Option des temps d’horloge")
	if (locale === "de") return /** @type {LocalizedString} */ ("Uhrzeit-Option")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzione tempi di orologio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опция «Время по часам»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opción de horas de reloj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时钟时间选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時計時間オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घड़ी समय विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opção de Horários do Relógio")
	return /** @type {LocalizedString} */ ("Clock Times Option")
});